import type { MutationTuple, OperationVariables } from '@apollo/client';
import { useApolloMutation, useCookie } from '@netfront/common-library';

import type { IUseCapuchinMutationOptions } from './useCapuchinMutation.interface';

export const useCapuchinMutation = <TData, TVariables extends OperationVariables = OperationVariables>({
  mutation,
  product,
  projectId,
  options,
  tokens,
}: IUseCapuchinMutationOptions<TData, TVariables>): MutationTuple<TData, TVariables> => {
  const { getImpersonatedUserTemporaryTokenCookie, getTemporaryTokenCookie } = useCookie();

  const temporaryToken = getImpersonatedUserTemporaryTokenCookie() ?? getTemporaryTokenCookie();

  return useApolloMutation({
    apiName: 'capuchin',
    mutation,
    options,
    product,
    projectId,
    tokens:
      tokens ??
      (temporaryToken
        ? {
            accessToken: temporaryToken,
            refreshToken: '',
          }
        : undefined),
  });
};
